// extracted by mini-css-extract-plugin
export default {"root":"Y1YdRa","link":"tl_Ja1","img":"oRh5l4"};